import { GitFSStats, WorkerAction, WorkerActionError, WorkerFnParams } from '../wasm-git.worker.model';
import { FSAction } from './actions.enum';

export interface FSStatAction extends WorkerAction {
  type: FSAction.Stat;
  params: { path: string };
}

class FSStatActionError extends WorkerActionError {}

export async function FSStatActionFn({ fs, params }: WorkerFnParams<FSStatAction>): Promise<GitFSStats> {
  const { path } = params;
  try {
    return fs.stat(path);
  } catch (err) {
    throw new FSStatActionError(err);
  }
}
